import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';
import slide3 from '../aseets/images/home/slide3.jpg';
import { useSettings } from '../contexts/SettingsContext';

const LegalNotice = () => {
  const { t } = useTranslation();
  const { settings, isLoading } = useSettings();
  
  // Valeur par défaut si les paramètres sont en cours de chargement
  const contactEmail = isLoading ? 'info@medagricycle.eu' : (settings.email || 'info@medagricycle.eu');

  return (
    <>
      <Navbar />
      <div class="home page-template page-template-page-templates page-template-fullwidth-content page-template-page-templatesfullwidth-content-php page page-id-4059 jet-theme-core jet-theme-core--has-template jet-theme-core--has-header jet-theme-core--has-body jet-theme-core--has-footer layout-fullwidth blog-masonry elementor-default elementor-kit-5747 elementor-page elementor-page-4059" style={{
        backgroundImage: `url(${slide3})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh'
      }}>
        <div id="jet-theme-core-document" class="jet-theme-core-document jet-theme-core-document--elementor-content-type">
          <div class="jet-theme-core-document__inner">
            <article id="post-4059" class="post-4059 page type-page status-publish hentry">	
              <div data-elementor-type="wp-page" data-elementor-id="4059" class="elementor elementor-4059">
                <section class="elementor-section elementor-top-section elementor-element elementor-element-ic2p76x elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="ic2p76x" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-im9c73l" data-id="im9c73l" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-0bd4fc3 elementor-widget elementor-widget-jet-slider" data-id="0bd4fc3" data-element_type="widget" data-widget_type="jet-slider.default">
                          <div class="elementor-widget-container">
                           
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                
      <div style={{
        minHeight: 'calc(100vh - 200px)',
        padding: '80px 20px 60px',
        maxWidth: '1200px',
        margin: '50px auto',
        fontFamily: 'Inter, sans-serif',
        position: 'relative'
      }}>
  <div style={{ inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
                                  <div style={{ background: 'rgba(0,0,0,0.45)', padding: '16px 24px', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.25)', backdropFilter: 'blur(2px)', maxWidth: '960px', width: '100%' }}>
                                    <h1 style={{ color: '#fff', fontSize: 'clamp(34px,6vw,56px)', fontWeight: 800, margin: 0, textAlign: 'center', letterSpacing: '0.5px' }}>
            {t('legalNotice.title', 'Legal Notice')}
          </h1>
                                  </div>
                                </div>

        <div style={{
          background: 'rgba(255, 255, 255, 0.95)',
          borderRadius: '16px',
          padding: '40px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          lineHeight: '1.8',
          color: '#333',
          backdropFilter: 'blur(5px)'
        }}>
         

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('legalNotice.companyInfo', 'Company Information')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              <strong>{t('legalNotice.projectName', 'Project Name')}:</strong> MedAgriCycle
            </p>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              <strong>{t('legalNotice.funding', 'Funding')}:</strong> PRIMA Programme, supported by the European Union
            </p>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              <strong>{t('legalNotice.coordinator', 'Coordinator')}:</strong> Erciyes University (ERU)
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('legalNotice.publication', 'Publication Director')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('legalNotice.publicationText', 'The publication director is responsible for the content published on this website.')}
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('legalNotice.hosting', 'Hosting')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('legalNotice.hostingText', 'This website is hosted on servers located within the European Union.')}
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('legalNotice.intellectualProperty', 'Intellectual Property')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('legalNotice.intellectualPropertyText', 'All content on this website, including texts, images, logos, and graphics, is protected by intellectual property rights. Reproduction, distribution, or use of this content without prior written authorization is prohibited.')}
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('legalNotice.liability', 'Liability')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('legalNotice.liabilityText', 'The information provided on this website is for general information purposes only. While we strive to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the website or the information contained on it.')}
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', color: '#2c3e50', marginBottom: '20px', fontWeight: 600 }}>
              {t('legalNotice.contact', 'Contact')}
            </h2>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              {t('legalNotice.contactText', 'For any questions regarding this legal notice, please contact us at:')}
            </p>
            <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
              <strong>Email:</strong> {contactEmail}
            </p>
          </section>

          <p style={{ 
            marginTop: '40px', 
            paddingTop: '20px', 
            borderTop: '2px solid #e5e7eb',
            fontSize: '0.9rem',
            color: '#6b7280',
            fontStyle: 'italic'
          }}>
            {t('legalNotice.lastUpdated', 'Last updated:')} {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
              </div>
            </article>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default LegalNotice;

